<div class="card-block side-card feature-card">
  <label class="control-label">
    <strong>Feature Image</strong>
  </label>
  <div class="feature-upload">
    <app-feature-image-upload
      [imageData]="_productService.featureImage || tempImage || placeholderUrl"
      [placeholder]="placeholderUrl"
    ></app-feature-image-upload>
  </div>
</div>
